import PropTypes from 'prop-types'
import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';

// import images
import client from "../../assets/images/client.png";
import transactionAmount from "../../assets/images/transactionAmount.png";
import transactionPrice from "../../assets/images/transactionPrice.png";
import tradeHistory from "../../assets/images/거래내역.jpg";
import news from "../../assets/images/news.jpg";

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import { dashboardResponse, mainResponse, newsResponse, postCollectSum, postDisposeSum, postProcessingWearing, postWearing } from 'crud/auth.crud';
import { useEffect } from 'react';
import defaultImg from "../../assets/images/default.png"

const Dashboard = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()
  const history = useHistory()

  const [isFetching, setIsFetching] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [newYear, setNewYear] = useState(moment(newDate).format("YYYY"))
  const [fixedYear, setfixedYear] = useState(moment(newDate).format("YYYY")) //최신으로 고정되는 년도값
  const [newDateText, setNewDateText] = useState(moment(newDate).format('DD'))
  const [newMonth, setNewMonth] = useState(moment(newDate).format("MM"))
  const [page, setPage] = useState(1)
  const [companyCount, setCompanyCount] = useState();
  const [collectSum, setCollectSum] = useState();
  const [collectMoneySum, setCollectMoneySum] = useState();
  const [newsList, setNewsList] = useState();
  const [isRefresh, setIsRefresh] = useState(false)
  const [dataList, setDataList] = useState([])
  const [monthDateText, setMonthDateText] = useState(moment(newDate).format("MM/DD") + '일자')
  const [maxDate, setMaxDate] = useState(new Date(moment(newDate).format("YYYY"), moment(newDate).format("MM"), 0).getDate())
  const [thisMonth, setThisMonth] = useState() //이달의 배출량
  const [prevMonth, setPrevMonth] = useState() //저번달의 배출량
  const [user, setUser] = useState(selector.auth?.user)
  const [myDisposeSum, setMyDisposeSum] = useState(0)
  const [myCollectSum, setMyCollectSum] = useState(0)
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM-DD') + ' 00:00:00')
  const [endDate, setEndDate] = useState(moment(nextDate.setDate(nextDate.getDate() + 1)).format('YYYY-MM-DD') + ' 00:00:00')

  const getCollectData = async () => {
    try {
      const params = {
        company: user.member_group?.[0]?.company_group?.id,
        start_ym: startDate,
        end_ym: endDate,
      }
      const response = await postCollectSum(params);
      if (response.data?.result === 'success') {
        const myCollectSum = response?.data?.data || 0;
        setMyCollectSum(myCollectSum)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDisposeData = async () => {
    try {
      const params = {
        company: user.member_group?.[0]?.company_group?.id,
        start_date: startDate,
        end_date: endDate,
      }
      const response = await postDisposeSum(params);
      if (response.data?.result === 'success') {
        const myDisposeSum = response?.data?.data || 0;
        setMyDisposeSum(myDisposeSum)
      }
    } catch (error) {
      console.error(error);
    }
  }

  // 지금 이 시간 웨이스트버스는? 가져오는 용
  const getDashboardData = async () => {
    const response = await dashboardResponse();    
    if(response.data?.result === 'success'){
      const item = response.data?.data
      setCompanyCount(Util.setAbbreviation(item.company_count));
      setCollectSum(Util.setAbbreviation(item.sum_collect));
      setCollectMoneySum(Util.setAbbreviation(item.sum_collect_money));
    }
  }

  // 웨이스트버스뉴스! 가져오는 용
  const getNewsList = async () => {
    try {
      const response = await newsResponse();
      if (response.status === 200) {        
        const tmpData = response.data?.results?.sort((a, b) => new Date(b.write_date).getTime() - new Date(a.write_date).getTime());
        const newsList = tmpData?.slice(0, 9).map(news => ({
          ...news,
          write_date: moment(new Date(news.write_date)).format('YYYY-MM-DD HH:mm:ss'),
          subject: Util.truncateString(Util.replaceHtmlTag(news.subject), 120),
          content: Util.truncateString(Util.replaceHtmlTag(news.content), 80),
        }));        
        setNewsList(newsList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCollectData();
    getDisposeData();
    getDashboardData();
    getNewsList();
  }, [])

  return (
    // <React.Fragment>
    //   <div className="page-content">
    //     <MetaTags>
    //       <title>홈 | 웨이스트버스</title>
    //     </MetaTags>
    //     <Container fluid>
    //       <div className="page-title-box">
    //         <Row className="align-items-center">
    //           <Col md={8}>
    //             <h6 className="page-title">관리 홈</h6>
    //             <ol className="breadcrumb m-0">
    //               <li className="breadcrumb-item active">'국내최초' 음식물류 폐기물 스마트 수거 플랫폼</li>
    //             </ol>
    //           </Col>

    //         </Row>
    //       </div>
    <>
      <Row>
        <Col xl={4}>
          <Card style={{ height: 300 }}>
            <CardBody>
              <Row>
                <Col>
                  <Row style={{ marginTop: 72 }}>
                    <Col md={6}>
                      <div className="text-center">
                        <p className="bottom-48" style={{fontSize: 18, fontWeight: 600, marginBottom :'48px', color: '#333'}}>총 수거량</p>
                        <h1 style={{fontSize: '36px', fontWeight: 600, color:'#BF9C46', lineHeight: '53px'}}>{Util.setPrice(myCollectSum)}L</h1>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="text-center">
                        <p className="bottom-48" style={{fontSize: 18, fontWeight: 600, marginBottom :'48px', color: '#333'}}>총 인계량</p>
                        <h1 style={{fontSize: '36px', fontWeight: 600, color:'#BF9C46', lineHeight: '53px'}}>{Util.setPrice(myDisposeSum)}L</h1>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col className='pointer' xl={4} md={12} onClick={()=>{history.push('collect-history')}}>
          <Card className="bg-primary bg-fill" style={{height: 300, backgroundImage: {tradeHistory}}}>
            <CardBody>
              <div className="text-center text-white py-4" style={{marginTop: 36}}>
                <h1 style={{fontWeight: 500}}>관리대장 보기</h1>
                <p className="text-white-50 mb-0" style={{marginTop: 36}}>
                  일자별, 월별 거래내역을 확인하세요!
                </p>
                <p style={{marginTop: 12}}>View more</p>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={2} md={6}>
          <Card className="mini-stat text-white bg-primary" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-4">
                <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                  
                </h5>
                <h4 className="fw-medium font-size-22 text-white">
                  지금 이 시간 웨이스트버스는?
                </h4>
              </div>
            </CardBody>
          </Card>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>  
                  <img src={transactionAmount} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-3 text-black-50 text-end">
                  총 거래량
                </h5>
                <h4 className="fw-medium pt-3 font-size-24 text-end">
                  {collectSum}kg{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={2} md={6}>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>
                  <img src={client} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-3 text-black-50 text-end">
                  고객사 수
                </h5>
                <h4 className="fw-medium font-size-24 pt-3 text-end">
                  {companyCount}개{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
          <Card className="mini-stat text-black" style={{height: '42.5%'}}>
            <CardBody>
              <div className="mb-0">
                <div className="float-start mini-stat-img me-4" style={{backgroundColor: '#95DBD1'}}>
                  <img src={transactionPrice} alt="" />
                </div>
                <h5 className="font-size-16 text-uppercase pt-4 text-black-50 text-end">
                  총 거래대금
                </h5>
                <h4 className="fw-medium pt-3 font-size-24 text-end">
                  {collectMoneySum}원{" "}
                </h4>
              </div>
            </CardBody>
          </Card>
        </Col> 
      </Row>

      <div className="page-title-box" style={{ paddingTop: 0 }}>
        <Row className="align-items-center">
          <Col md={12}>
            <h6 className="page-title">웨이스트버스뉴스!</h6>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">음식물 배출 및 재생원료에 대한 정보를 얻어가세요.</li>
            </ol>
          </Col>
        </Row>
      </div>

      <Row>
        {newsList && newsList.map((item, index) => { return (
          <Col xl={4} md={6} key={index}>
          <a href={item.link} style={{color: '#5b626b'}} target="_blank">
            <Card className="directory-card">
              <CardBody>
                <div className="d-flex">
                  <img
                    src={item.image_url}
                    alt="사진"
                    className="img-fluid avatar-lg"
                    style={{width: 6.5 + 'rem', height: 5.5 + 'rem', borderRadius: '4px'}}
                    onError={(e) => e.target.src = defaultImg}
                  />
                  <div className="flex-1 ms-4">
                    <h5 className="font-size-18 mt-0 mb-1 text-black">
                    {item.subject}
                    </h5>
                    {/* <p className="font-size-12 mb-2">{item.created_at.substr(11, 8)}</p> */}
                    <p className="mb-0 text-end font-size-12" style={{position: 'absolute', bottom: '1rem', right: '1rem'}}>{Util.formatNewsTime(item.write_date)}</p>
                  </div>
                </div>
              </CardBody>
            </Card>
            </a>
          </Col>
        )})
      }
      </Row>
    </>
    //     </Container>
    //   </div>

    // </React.Fragment>
  )
}

export default Dashboard